import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfosGenerales from './InfosGenerales';
import withLoader from 'components/Shared/withLoader';
import { invalidateReclamationInfosGenerales } from 'store/reclamation/detailsActions';
import { fetchReclamationInfosGeneralesIfNeeded } from 'store/reclamation/detailsActions';

const InfosGeneralesWithLoader = withLoader(InfosGenerales);

class InfosGeneralesContainer extends React.Component {

    componentDidMount() {
        this.props.fetchReclamationInfosGeneralesIfNeeded(this.props.reclamationId);
    }

    componenetDidUpdate(prevProps) {

        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.props.invalidateReclamationInfosGenerales();
            this.props.fetchReclamationInfosGeneralesIfNeeded(this.props.reclamationId);
        }
    }

    render() {
        return <InfosGeneralesWithLoader isLoading={this.props.isLoading} infosGenerales={this.props.infosGenerales} />;
    }
}

InfosGeneralesContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.isInfosGeneralesLoading,
    infosGenerales: state.reclamation.details.infosGenerales
});

const mapDispatchToProps = dispatch => ({
    invalidateReclamationInfosGenerales: () => dispatch(invalidateReclamationInfosGenerales()),
    fetchReclamationInfosGeneralesIfNeeded: id => dispatch(fetchReclamationInfosGeneralesIfNeeded(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfosGeneralesContainer);